import api from './api';

export interface VenueMap {
  id: string;
  name: string;
  svgUrl: string;
  isActive: boolean;
}

export interface MapZone {
  id: string;
  venueMapId: string;
  locationId: string;
  svgElementId: string;
  label?: string;
  bounds: { x: number; y: number; width: number; height: number };
  color?: string;
  order: number;
  Location?: { id: string; name: string; capacity?: number };
  activeEvents?: any[];
}

export interface MapData {
  map: VenueMap;
  zones: MapZone[];
}

const mapService = {
  async getActiveMap(): Promise<MapData | null> {
    const response = await api.get('/map');
    // Backend returns { map, zones } directly (not wrapped in data)
    const result = response.data.data || response.data;
    if (!result || !result.map) return null;
    return result;
  },

  async uploadMap(file: File, name: string): Promise<VenueMap> {
    const formData = new FormData();
    formData.append('svg', file); // multer expects field name 'svg'
    formData.append('name', name);
    const response = await api.post('/map', formData, {
      headers: { 'Content-Type': undefined }, // let Axios set boundary
    });
    return response.data.data || response.data;
  },

  async updateMap(id: string, data: Partial<VenueMap>): Promise<VenueMap> {
    const response = await api.put(`/map/${id}`, data);
    return response.data.data || response.data;
  },

  async saveZones(mapId: string, zones: Partial<MapZone>[]): Promise<MapZone[]> {
    const response = await api.post(`/map/${mapId}/zones`, { zones });
    return response.data.data || response.data;
  },

  async deleteMap(id: string): Promise<void> {
    await api.delete(`/map/${id}`);
  },
};

export default mapService;
